const errorHandler = (context, err, callback, toastType = 'snack', toastTime = 3E3) => {
  const error = err.data && err.data.error ?
    err.data.error :
    err;
  context.$toast.create(error, toastType, toastTime);
  if (callback) {
    callback();
  }
};

function plugin(Vue) {
  Vue.prototype.$error = errorHandler;
}

if (typeof window !== 'undefined' && window.Vue) { // eslint-disable-line no-undef
  window.Vue.use(plugin); // eslint-disable-line no-undef
}

// module.exports = plugin;
export default plugin;



// WEBPACK FOOTER //
// ./src/common/functions/error-handler.js